import { render } from "./DetailHead.vue?vue&type=template&id=0826a5f6"
import script from "./DetailHead.vue?vue&type=script&lang=js"
export * from "./DetailHead.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DetailHead.vue?vue&type=style&index=0&id=0826a5f6&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/tex/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__